<template>
    <div class="modal-invoice">
        <SOSlotModal :modal-title="modalTitle" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="py-4">
                    <p class="f-16 f-reg-black m-d-16">Pembuatan invoice akan dikenakan biaya minimal 1000 M-Coin.</p>
                    <ul class="f-14 f-reg-black p-l-20">
                        <li>Jika mengirim <span class="f-bold">1-20 nota</span>, maka dikenakan biaya 1000 M-Coin.</li>
                        <li>
                            Jika invoice <span class="f-bold">>20 nota</span>, akan dikenakan
                            <span class="f-bold">tambahan biaya 50 M-Coin/nota tambahan</span>. Misal, invoice berisi 21
                            nota transaksi maka dikenakan biaya 1.050 M-Coin.
                        </li>
                        <li>
                            Apabila saat pembuatan invoice saldo M-Coin tidak mencukupi, maka anda <span class="f-bold">tidak dapat membuat
                            invoice.</span>
                        </li>
                    </ul>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";

export default {
    name: "DetailBiaya",
    components: {
        SOSlotModal,
    },
    data() {
        return {
            modalId: "detail-biaya",
            modalTitle: "Biaya Pembuatan Invoice",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    methods: {
        async back(idx = -1) {
            await this.$router.go(idx);
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
    },
};
</script>
<style scoped src="../../static/style.css"></style>
